import { useQuery } from '@tanstack/react-query';
import { admin } from './admin-api';

export default function System() {
  const sys = useQuery({ queryKey: ['admin', 'system'], queryFn: admin.system, refetchInterval: 5000 });

  if (sys.isLoading) return <div className="small faint">Loading system info…</div>;
  if (sys.isError) return <div className="login-err">Could not load system info.</div>;
  const s = sys.data!;

  return (
    <div>
      <div className="ph">Admin · System</div>
      <div className="h2">Backend status</div>
      <p className="lead">Live VPS health. Updates every 5 seconds.</p>

      <div className="grid2">
        <div className="panel">
          <div className="qhead"><span className="qdot" style={{ background: 'var(--teal)' }} />Process</div>
          <Row k="Uptime" v={`${Math.floor(s.uptime_s / 60)} min ${s.uptime_s % 60} s`} />
          <Row k="Memory" v={`${s.memory_mb.toFixed(1)} MB`} />
          <Row k="Recent restarts (24h)" v={`${s.recent_restarts ?? 0}`} />
          {s.cert_expires_at && <Row k="TLS cert expires" v={new Date(s.cert_expires_at).toLocaleDateString()} />}
        </div>

        <div className="panel">
          <div className="qhead"><span className="qdot" style={{ background: 'var(--gold)' }} />Database</div>
          <Row k="DB file size" v={`${(s.db_size_kb / 1024).toFixed(2)} MB`} />
          {Object.entries(s.table_row_counts).map(([table, count]) => (
            <Row key={table} k={table} v={`${count} rows`} />
          ))}
        </div>
      </div>
    </div>
  );
}

function Row({ k, v }: { k: string; v: string }) {
  return (
    <div className="row" style={{ justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #241f18' }}>
      <span style={{ fontSize: 14 }}>{k}</span>
      <span className="mono small">{v}</span>
    </div>
  );
}
